<template>
  <div>
    <div v-show="!$root.locked" class="oneui">
      <div>
        <ul
          class="nameWrapper"
          :style="`grid-template-columns: repeat(${$root.$data.kids.length}, 1fr)`"
        >
          <li v-for="kid in $root.$data.kids" :key="`${kid.id}____top`"></li>
          <li
            :key="`${kid.id}____`"
            :class="$root.$data.selectedChild == kindex ? 'current' : null"
            v-for="(kid, kindex) in $root.$data.kids"
            @click="$root.$data.selectedChild = kindex"
          >
            <span>{{ kid.get("name") }}</span>
          </li>
          <li>
            <span v-if="$root.kids.length == 0">{{ $t("generic.loading") }}</span>
          </li>
          <li v-if="$root.kids.length == 0"></li>
          <li v-for="kid in $root.$data.kids" :key="`${kid.id}___bottom`"></li>
        </ul>
      </div>
      <div class="pageWrapper" v-if="$root.$data.kids.length !== 0">
        <div
          :style="
            $root.$data.selectedChild > kindex
              ? 'transform: translateX(-100vw)'
              : 'transform: translateX(100vw)'
          "
          :class="`page ${
            kid.get('name') == $t('generic.serverSideErrorTitle') ? 'center-div' : ''
          } ${$root.$data.selectedChild == kindex ? 'pit' : ''}`"
          :id="`tab-${kid.id}`"
          v-for="(kid, kindex) in $root.$data.kids"
          :key="kid.id"
        >
          <div v-if="kid.get('name') !== 'Unable to connect to server'">
            <ChoreContainerHeader
              :isFuture="isFuture"
              :kindex="kindex"
              @toggle="setFuture"
            >
              <reward
                @edit="changeRewardPoints($event)"
                :updater="kid"
                :kid="kid"
                :reward="kid.get('customReward')"
              />
            </ChoreContainerHeader>
            <div id="choreContainer">
              <div class="card filters fhorizontal">
                <div
                  @click="isFuture = false"
                  :class="!isFuture ? 'center-div selected' : 'center-div'"
                >
                  {{ $t("pages.parents.todaysChores") }}
                </div>
                <div
                  @click="isFuture = true"
                  :class="isFuture ? 'center-div selected' : 'center-div'"
                >
                  {{ $t("pages.parents.futureChores") }}
                </div>
              </div>
              <transition-group name="list" tag="div">
                <div key="choreCP" v-if="!isFuture" class="cardContainer">
                  <div
                    v-if="
                      choresFor(kindex).filter(
                        (chore) =>
                          (chore.get('repeats') == '0.0.0.0.0.0.0' ||
                            chore.get('repeats').split('.')[new Date().getDay()] ==
                              '1') &&
                          (typeof chore.get('dateConfirmed') == 'undefined' ||
                            chore.get('dateConfirmed') !== new Date().toDateString())
                      ).length == 0
                    "
                    class="card allDone card-slim"
                  >
                    <h3>{{ $t("pages.parents.noChores") }}</h3>
                    <p>{{ $t("pages.parents.noChoresSubtext") }}</p>
                  </div>
                  <div
                    v-for="chore in choresFor(kindex).filter(
                      (chore) =>
                        chore.get('done') ||
                        chore.get('repeats') == '0.0.0.0.0.0.0' ||
                        (chore.get('repeats').split('.')[new Date().getDay()] == '1' &&
                          (typeof chore.get('dateConfirmed') == 'undefined' ||
                            chore.get('dateConfirmed') !== new Date().toDateString()))
                    )"
                    :key="chore.id + 'present'"
                    :id="`${chore._id}`"
                  >
                    <chore
                      :chore="chore"
                      @click.native="
                        chore.get('done')
                          ? approve(kid, chore, chore.id + 'future')
                          : null
                      "
                    ></chore>
                  </div>
                </div>
                <div key="choreCF" class="cardContainer" v-else>
                  <div
                    class="card allDone card-slim"
                    v-if="
                      choresFor(kindex).filter(
                        (chore) =>
                          !(
                            (chore.get('repeats') == '0.0.0.0.0.0.0' ||
                              chore.get('repeats').split('.')[new Date().getDay()] ==
                                '1') &&
                            (typeof chore.get('dateConfirmed') == 'undefined' ||
                              chore.get('dateConfirmed') !== new Date().toDateString())
                          )
                      ).length == 0
                    "
                  >
                    <h3>{{ $t("pages.parents.noRepeatingChores") }}</h3>
                    <p>{{ $t("pages.parents.noRepeatingChoresSubtext") }}</p>
                  </div>
                  <chore
                    :id="`${chore._id}`"
                    v-for="chore in choresFor(kindex).filter(
                      (chore) =>
                        !chore.get('done') &&
                        !(
                          (chore.get('repeats') == '0.0.0.0.0.0.0' ||
                            chore.get('repeats').split('.')[new Date().getDay()] ==
                              '1') &&
                          (typeof chore.get('dateConfirmed') == 'undefined' ||
                            chore.get('dateConfirmed') !== new Date().toDateString())
                        )
                    )"
                    :key="chore.id + 'future'"
                    :chore="chore"
                    isFuture="yes"
                    @click.native="
                      chore.get('done') ? approve(kid, chore, chore.id + 'present') : null
                    "
                  />
                </div>
              </transition-group>
            </div>
          </div>
          <div class="center-div" v-else>
            <div class="card center-div">
              <p>{{ $t("generic.serverSideError") }}</p>
              <button @click="fixLogin">Logout</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="pageWrapper">
        <div
          :style="'transform: translateX(100vw)'"
          :class="`page pit`"
          :id="`tab-loading`"
        >
          <div>
            <div id="choreContainer">
              <div class="card filters fhorizontal">
                <div
                  @click="isFuture = false"
                  :class="!isFuture ? 'center-div selected' : 'center-div'"
                >
                  {{ $t("pages.parents.todaysChores") }}
                </div>
                <div
                  @click="isFuture = true"
                  :class="isFuture ? 'center-div selected' : 'center-div'"
                >
                  {{ $t("pages.parents.futureChores") }}
                </div>
              </div>
              <transition-group name="list" tag="div">
                <div key="choreCP" class="cardContainer">
                  <div class="card allDone card-slim">
                    <h3>{{ $t("pages.parents.loadingChores") }}</h3>
                    <p>{{ $t("pages.parents.pleaseWait") }}</p>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LockScreen v-show="$root.locked"></LockScreen>
    <v-style v-if="$root.locked" :updater="$root.locked">
      .pageview { grid-template-rows: 'unset' } .tabbar { z-index:-100; }
    </v-style>
  </div>
</template>

<script>
/* NPM IMPORTS */
import * as ModernModals from "modern-modals";
window.ModernModals = ModernModals;
/* JS IMPORTS */
import * as CCDb from "@/utilities/db.js";

/* COMPONENT IMPORTS */
import Chore from "../../components/Chore";
import Reward from "../../components/Reward";
import ChoreContainerHeader from "../../components/ChoreContainerHeader";
import LockScreen from "../../components/LockScreen";
export default {
  name: "ParentsHome",
  components: {
    Chore,
    Reward,
    ChoreContainerHeader,
    LockScreen,
  },
  data() {
    return {
      isFuture: false,
      locked: false,
      correctPin: "",
      window: window,
    };
  },
  async mounted() {
    let conti = true;
    const user = CCDb.currentUser();
    if (user) {
      await CCDb.getParent();
      if (window.hasMountedHome) {
        VueInstance.$children[0].$children.forEach((x) => x.$forceUpdate());
      } else {
        this.$root.$data.locked = true;
      }
      window.hasMountedHome = true;
      // The Branch SDK is vendored in public/scripts but it is not loaded by
      // the web build and it has no key, so this call cannot work there.
      if (typeof branch !== "undefined") branch.identify(user.uid);
    } else this.$router.push("/login");
  },
  methods: {
    /**
     * The chores of one child.
     *
     * The list is empty until the chores are loaded, so the page renders
     * before the first read is done.
     */
    choresFor(kindex) {
      const list = this.$root.$data.chores[kindex];
      return Array.isArray(list) ? list : [];
    },
    setFuture(val) {
      this.$data.isFuture = val;
    },
    fixLogin() {
      localStorage.clear();
      location.reload();
    },
    async changeRewardPoints(child) {
      let action = await ModernModals.select({
        title: "Would you like to edit or remove this reward?",
        choices: [
          { text: "Edit Reward", value: "edit" },
          { text: "Remove Reward", value: "remove" },
        ],
      });
      if (action == "edit") {
        let points = prompt("Choose new point value", child.get("rewardValue"));
        child.set("rewardValue", Number(points));
        await child.save();
      } else {
        const x = await ModernModals.prompt(`Are you sure you want remove this reward?`);
        if (x) {
          const customReward = child.get("customReward");
          if (customReward) {
            // Wait for the delete, otherwise the list is reloaded while the
            // reward is still there.
            await customReward.destroy();
          }
          child.set("customReward", null);
          await child.save();
        }
      }
      await VueInstance.initLoadChores();
    },
    async approve(kid, chore, el) {
      let promptRet = await ModernModals.select({
        title: `Did ${kid.get("name")} finish ${chore.get("name")}?`,
        choices: [
          {
            text: "Yes, confirm!",
            value: 0,
          },
          {
            text: "No, reassign!",
            value: 1,
          },
          {
            text: this.$t("generic.cancel"),
            value: 2,
          },
        ],
      });
      switch (promptRet) {
        case 0:
          if (chore.get("repeats").split(".").includes("1")) {
            let date = new Date();
            chore.set("dateConfirmed", date.toDateString());
            chore.set("done", false);
            await chore.save();
          } else {
            // Wait for the delete, otherwise the list is reloaded while the
            // chore is still there.
            await chore.destroy();
          }
          await this.$root.loadChores();
          break;
        case 1:
          // Take the points off with an increment, so a chore that was
          // finished on another device at the same time is not overwritten
          // with a stale total.
          kid.increment("points", -(Number(chore.get("points")) || 0));
          chore.set("done", false);
          await chore.save();
          await kid.save();
          await VueInstance.initLoadChores();
          break;
        case 2:
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lock {
  z-index: 9998;
}

$headw: 10%;
$headmnw: 125px;

.list {
  &-enter,
  &-leave {
    &-active {
      transition: opacity 0.5s;
    }
  }
  &-enter, &-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  &-enter-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}

.pit[style] {
  transform: translateX(0vw) !important;
  height: fit-content;
  overflow: visible;
}
.page {
  transition: transform 0.5s cubic-bezier(0.18, 0.89, 0.3, 1.15);
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  overflow-x: hidden;
  height: 110vh;
}
</style>
